import {
  string, shape, arrayOf, params, extend, bool
} from '@thd-nucleus/data-sources';
import {
  ProductPod,
  ProductATC,
  ProductRating,
  ProductImage,
  ProductBadge,
} from '@thd-olt-component-react/product-pod';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { Price } from '@thd-olt-component-react/price';

/**
 * We define the ProductPod's dataModel explicitly, as part of the solution to the problem found in HD-Home experience.
 * @see https://thdengops.slack.com/archives/C061ED13N5S/p1703134137467689?thread_ts=1702659382.502669&cid=C061ED13N5S
 */
const productPod = {
  dataModel: {
    product: params({
      itemId: string().isRequired(),
      dataSource: string(),
    }).shape({
      itemId: string(),
      dataSources: string(),
      badges: params({ storeId: string() }).arrayOf(
        shape({
          name: string(),
        })
      ),
      identifiers: shape({
        canonicalUrl: string(),
      }),
      info: shape({
        sponsoredMetadata: shape({
          campaignId: string(),
          placementId: string(),
          slotId: string(),
          sponsoredId: string(),
          trackSource: string(),
        }),
        sponsoredBeacon: shape({
          onClickBeacons: arrayOf(string()),
          onViewBeacons: arrayOf(string()),
        }),
      }),
      availabilityType: shape({
        discontinued: bool(),
        type: string(),
      }),
    }),
  },
};
// --

export const dataModel = extend(
  ProductPod,
  ProductImage,
  Price,
  ProductATC,
  ProductRating,
  ProductHeader,
  ProductBadge,
  productPod.dataModel
);